import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom'; // Import useNavigate
import Swal from "sweetalert2";
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { getEventAll } from '../services/dbService'; // Your API service
import PaginatedTable from '../services/paginatedtable'; // Your table component
import "./dashboard.css"; // Your custom CSS

function EventAll() {
  const [searchParams] = useSearchParams(); // Keep if potentially used elsewhere, otherwise remove
  // const [id, setId] = useState(null); // Removed: Not used
  // const [total, setTotal] = useState(); // Removed: Not used
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Correctly initialized as an empty array
  const [error, setError] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false); // Removed: Not used

  const navigate = useNavigate(); // Initialize useNavigate hook

  // Removed selected state as it's not strictly necessary for direct navigation
  // const [selected, setSelected] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null); // Clear previous errors
    try {
      const response = await getEventAll();
      // Ensure response.data is an array; if not, default to empty
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching event data:", err); // Log the actual error
      Swal.fire('Error', 'Failed to retrieve event data. Please try again.', 'error');
      setError('Failed to load event data.'); // Set a user-friendly error message
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array means this runs once on component mount

  const handleEdit = (item) => {
    // Navigate using React Router's navigate function for smoother transitions
    navigate(`/events?id=${item.id}`);
  };

  const handleregistrations = (item) => {
    // Navigate using React Router's navigate function for smoother transitions
    navigate(`/eventregistrations?id=${item.id}`);
  };

  return (
    <div>
      <Navbar />
      <Sidebar />

      {/* Conditional preloader display */}
      {loading && (
        <div className="preloader" style={{ display: 'block' }}>
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              {/* Removed unused .folio-container */}
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between"> {/* Removed mb-4 */}
                        <h4 className="card-title text-white fw-semibold mb-0">Events</h4> {/* Added text-white for contrast */}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <Link to='/events'>
                          <button
                            className="btn btn-info btn-sm me-2 fw-semibold" // Added fw-semibold
                            style={{ minWidth: 130 }}
                          >
                            New
                          </button>
                        </Link>
                      </div>
                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading events...</p> // More specific loading message
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "name",
                                "startdate",
                                "enddate",
                                "starttime",
                                "endtime",
                                "description",
                                "registrationallowed",
                                "status",
                              ]}
                              data={data}
                              onEdit={handleEdit}
                              openRegistrations={handleregistrations}
                              showopenregistrations={true}
                            />
                          </div>
                        ) : (
                          <p className="text-muted">No event data available.</p> 
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventAll;